import {
  LEAVEREQUEST_ALL,
  LEAVEREQUEST_GET,
  LEAVEREQUEST_DEL,
  LEAVEREQUEST_PUT,
  LEAVEREQUEST_POST,
  LEAVEREQUEST_LOADING,
  LEAVEREQUEST_ERROR,
  LEAVEREQUEST_PENDING_COUNT,
} from '../types';
import api from '../../../utils/functions/api';

export const leaveRequestAll = (params = {}) => async (dispatch) => {
  try {
    const { me = '', status = '', size = 999999, page = 1, dateStart = '', dateEnd = '' } = params;
    const { data, status: httpStatus } = await api.get(
      `${process.env.REACT_APP_API_URL}/leave-request?me=${me}&status=${status}&size=${size}&page=${page}&dateStart=${dateStart}&dateEnd=${dateEnd}`,
    );
    if (httpStatus === 200) {
      dispatch({ type: LEAVEREQUEST_ALL, payload: data });
    }
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw new Error(error);
  }
};

export const leaveRequestGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/leave-request/${id}`,
    );
    if (status === 200) {
      dispatch({ type: LEAVEREQUEST_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw new Error(error);
  }
};

export const leaveRequestCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: LEAVEREQUEST_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/leave-request`,
      payload,
    );
    dispatch({ type: LEAVEREQUEST_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw error;
  }
};

export const leaveRequestPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: LEAVEREQUEST_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/leave-request/${id}`,
      payload,
    );
    dispatch({ type: LEAVEREQUEST_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw new Error(error);
  }
};

export const leaveRequestDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: LEAVEREQUEST_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/leave-request/${id}`,
    );
    dispatch({ type: LEAVEREQUEST_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw new Error(error);
  }
};

export const leaveRequestApprove = (id, approver_id, note) => async (dispatch) => {
  try {
    dispatch({ type: LEAVEREQUEST_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/leave-request/${id}/approve`,
      { approver_id, note },
    );
    dispatch({ type: LEAVEREQUEST_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw new Error(error);
  }
};

export const leaveRequestReject = (id, approver_id, note) => async (dispatch) => {
  try {
    dispatch({ type: LEAVEREQUEST_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/leave-request/${id}/reject`,
      { approver_id, note },
    );
    dispatch({ type: LEAVEREQUEST_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LEAVEREQUEST_ERROR });
    throw new Error(error);
  }
};

export const leaveRequestPendingCount = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/leave-request?status=PENDING&size=1&page=1`,
    );
    if (status === 200) {
      const count = data?.total ?? data?.rows?.length ?? 0;
      dispatch({ type: LEAVEREQUEST_PENDING_COUNT, payload: count });
    }
  } catch (error) {
    console.error(error);
  }
};
